<template>
    <template v-for="error in  GoConnect.errors.errors" :key="error">
        <div v-if="error.level === 'success'" class="alert alert-success alert-dismissible fade show" role="alert">
            <i class="alert-icon fas fa-info-circle fa-2x"></i>
            <span>{{ error.message }}</span>
            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
        </div>
        <div v-else-if="error.level === 'error'" class="alert alert-danger alert-dismissible fade show" role="alert">
            <i class="alert-icon fas fa-exclamation-circle  fa-2x"></i>
            <span>{{ error.message }}</span>
            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
        </div>
        <div v-else-if="error.level === 'warning'" class="alert alert-warning alert-dismissible fade show" role="alert">
            <i class="alert-icon fas fa-exclamation-circle fa-2x"></i>
            <span>{{ error.message }}</span>
            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
        </div>
        <div v-else-if="error.level === 'info'" class="alert alert-light alert-dismissible fade show" role="alert">
            <i class="alert-icon fas fa-info-circle fa-2x text-muted"></i>
            <span>{{ error.message }}</span>
            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
        </div>
    </template>
</template>

<script setup>
import { inject, watch } from 'vue';
import { useRoute } from 'vue-router';

const GoConnect = inject('GoConnect');
const route = useRoute();

watch(route, () => {
    GoConnect.errors.markAllAsRead();
});

</script>
